import React from "react";
import {Field} from "react-final-form";

function Error({name}) {
    return <Field
        name={name}
        subscribe={{ touched: true, error: true, submitError: true, dirtySinceLastSubmit: true }}
        render={({ meta: { touched, error, submitError, dirtySinceLastSubmit } }) =>
            (touched && error) || (!dirtySinceLastSubmit && submitError) ?
                <div className="error-msg scroll-to-error">{error || submitError}</div> :
                null
        }
    />
}

export default Error;